<qrcode
  *ngIf="url"
  [qrdata]="url"
  [width]="size"
  [errorCorrectionLevel]="'M'"
  [elementType]="'svg'"
>
</qrcode>
